/**
 * Studio → Bundles (deferred parent route) — #152.
 *
 * Bundles and Industry Kits keep their tables/routes so historical data is
 * preserved, but the tenant V1 surface shows an honest deferred page instead
 * of exposing incomplete authoring, publishing, install, or archive actions.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  DeferredStudioFeature,
  STUDIO_BUNDLES_DEFERRED_MESSAGE,
} from './-deferred-feature';

export const Route = createFileRoute('/studio/bundles')({
  component: StudioBundlesLayout,
});

function StudioBundlesLayout() {
  const navigate = useNavigate();
  return (
    <DeferredStudioFeature
      title="Bundles and Industry Kits are deferred"
      description={STUDIO_BUNDLES_DEFERRED_MESSAGE}
      onBack={() => navigate({ to: '/studio/tools' })}
      backLabel="Back to Studio Tools"
    />
  );
}
